module.exports = __webpack_public_path__ + "img/austria-mental-and-behavioural-disorders-female.e8eb1f9a.png";